import Dashboard from '@/views/Dashboard/Dashboard';
import { permission } from '../middleware/permissions';

export default [
  {
    path: '/',
    name: 'Dashboard',
    // component: () => import(
    //   /* webpackChunkName: "Dashboard" */
    //   /* webpackPrefetch: true */
    //   /* webpackPreload: true */
    //   '@/views/Dashboard/Dashboard'
    // ),
    component: Dashboard,
    meta: {
      title: 'headerTitles.Dashboard',
      showToolbarElements: ['bookAppointment', 'createPatient', 'createProvider'],
      middleware: [permission],
      permission: {
        name: 'VIEW_APPOINTMENTS',
        role: 'CLINIC_ADMIN',
        fallbackPage: 'Settings',
      },
    },
  },
  {
    path: '/super-bill',
    name: 'SuperBill',
    component: () => import(/* webpackChunkName: "superBill" */'@/views/Services/Services'),
    meta: {
      title: 'headerTitles["Super Bill"]',
    },
  },
  {
    path: '/booking',
    name: 'Booking',
    component: () => import(/* webpackChunkName: "booking" */ '@/views/Booking/Booking'),
    meta: {
      title: 'headerTitles["Appointment"]',
      showToolbarElements: ['bookAppointment'],
    },
    props: true,
  },
  {
    path: '/appointments',
    name: 'Appointments',
    component: () => import(/* webpackChunkName: "appointments" */'@/views/Appointments/Appointments'),
    meta: {
      title: 'headerTitles["Appointments"]',
      showToolbarElements: ['booking'],
    },
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: () => import(/* webpackChunkName: "schedule" */ '@/views/Schedule/Schedule'),
    meta: {
      title: 'headerTitles["schedule"]',
    },
  },
  {
    path: '/chat',
    name: 'Messenger',
    component: () => import(/* webpackChunkName: "messages" */ '@/views/Messenger/Messenger'),
    meta: {
      title: 'headerTitles.Messages',
    },
  },
  {
    path: '/clinics',
    name: 'Clinics',
    component: () => import(/* webpackChunkName: "clinics" */'@/views/Clinics/Clinics'),
    meta: {
      title: 'headerTitles["Clinics"]',
      showToolbarElements: ['createClinic'],
    },
  },
  {
    path: '/clinics/create',
    name: 'CreateClinic',
    component: () => import(/* webpackChunkName: "form-clinic" */ '@/views/Clinics/ClinicForm/index'),
    meta: {
      title: 'headerTitles["Creating Clinic"]',
    },
  },
  {
    path: '/clinics/edit/:id',
    name: 'EditClinic',
    component: () => import(/* webpackChunkName: "edit-form-clinic" */ '@/views/Clinics/ClinicForm/index'),
    meta: {
      title: 'headerTitles["Edit Clinic"]',
    },
  },
  {
    path: '/profile/:page?',
    name: 'MyProfile',
    component: () => import(/* webpackChunkName: "my-profile" */ '@/views/MyProfile/MyProfile'),
    meta: {
      title: 'headerTitles["myProfile"]',
    },
    props: route => ({
      page: route.params.page,
    }),
  },
  {
    path: '/reports',
    name: 'ReportGenerator',
    component: () => import(/* webpackChunkName: "report-generator" */ '@/views/Reports/ReportGenerator'),
    meta: {
      title: 'headerTitles["Generate Reports"]',
    },
  },
  {
    path: '/view-patient/:patientId/:page?',
    name: 'PatientProfile',
    component: () => import(/* webpackChunkName: "patient-profile" */ '@/views/PatientProfile/PatientProfile'),
    meta: {
      title: 'headerTitles["profilePatientInfo"]',
    },
    props: route => ({
      patientId: route.params.patientId,
      page: route.params.page,
    }),
  },
  {
    path: '/view-patient-rpm/:patientId',
    name: 'RpmPatientProfile',
    component: () => import(/* webpackChunkName: "ViewRpmProfile" */ '@/views/RpmPatientProfile/PatientProfile'),
    meta: {
      title: 'sidebar["rpmMonitoring"]',
    },
    props: route => ({
      patientId: route.params.patientId,
    }),
  },
  {
    path: '/waiting-room/:roomId/:appointmentId',
    name: 'WaitingRoom',
    component: () => import('@/views/WaitingRoom/WaitingRoom'),
    meta: {
      title: 'headerTitles["Waiting Room"]',
    },
  },
  {
    path: '/consult/:roomId/:appointmentId',
    name: 'VideoCall',
    component: () => import(/* webpackChunkName: "video-call" */ '@/views/VideoCall/VideoCall'),
    meta: {
      title: 'headerTitles["Video Meeting"]',
      showToolbarElements: ['videoCallProgress'],
      appElementSettings: ['miniSidebar'],
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings/SettingsPage'),
    meta: {
      title: 'sidebar.settings',
    },
    props: {
      usersRole: 'SUPER_ADMIN',
    },
  },
];
